<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 1vh 1vw;">
		<div style="text-align: right;">
			<el-form :inline="true" :model="queryForm">
				<el-form-item>
					<el-button @click="open(mode='create',priceListId='')" type="primary" >新增价格表</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="margin-top: 2vh;">
			<el-table :data="data" style="width: 100%"
				:header-cell-style="{background:'#eceff4',color:'#7f7f7f','font-weight': 500,'font-family': 'sans-serif','color': '#000'}">
				<el-table-column prop="priceListName" label="价格表名称" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="creationTime" label="创建时间" header-align="center"
					align="center"></el-table-column>
				<el-table-column label="操作" header-align="center" align="center">
					<template #default="scope">
						<el-button type="text"
							@click="open(mode='see',priceListId=scope.row.priceListId)">查看详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [],
				queryForm: {
					user: ""
				},
				createWindow: false
			}
		},
		methods: {
			open(mode, priceListId) {
				this.$router.push({
					path: "/finance/priceDetails",
					query: {
						mode: mode,
						priceListId: priceListId
					}
				});
			},
			getPriceList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "newPriceList",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.data = res.data.priceList;
						}
					})
					.finally(() => {
						loading.close();
					})
				
			}
		},
		mounted() {
			this.getPriceList()
		}
	}
</script>

<style scoped>

</style>